<template>
    <div>
        <b-form @submit.prevent="saveIndicationOfDanger()" data-vv-scope="formIndicationOfDanger">
            <b-row>
                <b-col md="6">
                    <b-form-group>
                        <label>Código <span class="text-danger">*</span></label>
                        <b-form-input v-model="indicationOfDanger.code" type="text" class="form-control" name="code"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formIndicationOfDanger.code')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input v-model="indicationOfDanger.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formIndicationOfDanger.name')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Consejo de prudencia</label>
                        <el-select v-model="indicationOfDanger.prudence_tip_code_ids" clearable filterable multiple
                            size="medium" placeholder="Seleccionar consejo de prudencia" name="prudence_tip_code_ids"
                            v-validate="''" data-vv-as=" ">
                            <el-option v-for="item in activeTipsPrudenceSga" :key="item.id"
                                :label="item.code + ' - ' + item.name" :value="item.id" />
                        </el-select>
                        <span class="text-danger small"
                            v-text="errors.first('formIndicationOfDanger.prudence_tip_code_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <b-form-checkbox v-model="parent" name="parent" :value="true" :unchecked-value="false" switch>
                            Agregar indicación de peligro padre
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="parent">
                    <b-form-group>
                        <label>Indicación de peligro padre <span class="text-danger">*</span></label>
                        <el-select v-model="indicationOfDanger.parent_danger_indication_code_ids" clearable filterable
                            multiple size="medium" placeholder="Seleccionar indicación de peligro"
                            name="parent_danger_indication_code_ids" v-validate="parent == true ? 'required' : ''"
                            data-vv-as=" ">
                            <el-option v-for="item in filteredActiveIndicationsOfDangerSga" :key="item.id"
                                :label="item.code + ' - ' + item.name" :value="item.id" />
                        </el-select>
                        <span class="text-danger small"
                            v-text="errors.first('formIndicationOfDanger.parent_danger_indication_code_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="hasValidLanguages">
                    <b-list-group>
                        <b-list-group-item v-for="language in indicationOfDanger.sga_danger_indication_code_languages"
                            :key="language.id" v-if="language.sga_language.code !== 'ES'">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                    <span class="fw-bold">
                                        <input v-model="language.value" type="text"
                                            class="form-control form-control-sm w-100" />
                                    </span>
                                </div>
                                <div class="ms-auto ml-2">
                                    <b-badge variant="primary">{{ language.sga_language.code }}</b-badge>
                                    <span class="text-muted"> - {{ language.sga_language.name }}</span>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelIndicationOfDanger">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormIndicationsOfDanger',

    data() {
        return {
            parent: false,
        };
    },

    computed: {
        ...mapState('sgaIndicationsOfDanger', ['action', 'indicationOfDanger', 'activeIndicationsOfDangerSga']),
        ...mapState('sgaTipsPrudence', ['activeTipsPrudenceSga']),

        hasValidLanguages() {
            return Array.isArray(this.indicationOfDanger.sga_danger_indication_code_languages) &&
                this.indicationOfDanger.sga_danger_indication_code_languages.length > 0;
        },

        // Filtrar las indicaciones de peligro activas para no mostrar la indicación de peligro actual
        filteredActiveIndicationsOfDangerSga() {
            if (this.indicationOfDanger.id !== null && Array.isArray(this.activeIndicationsOfDangerSga)) {
                return this.activeIndicationsOfDangerSga.filter(item => item.id !== this.indicationOfDanger.id);
            }
            return this.activeIndicationsOfDangerSga;
        }
    },

    watch: {
        parent(value) {
            if (!value) {
                this.indicationOfDanger.parent_danger_indication_code_ids = [];
            }
        },

        // Asignar los códigos de las indicaciones de peligro padre
        "indicationOfDanger.parent_danger_indication_codes": {
            handler(value) {
                if (Array.isArray(value) && value.length > 0) {
                    this.parent = true;
                    this.indicationOfDanger.parent_danger_indication_code_ids = value.map(item => item.parent_danger_indication_code_id);
                }
            },
            deep: true
        },

        // Asignar los códigos de los consejos de prudencia
        "indicationOfDanger.sga_prudence_tip_codes": {
            handler(value) {
                if (Array.isArray(value) && value.length > 0) {
                    this.indicationOfDanger.prudence_tip_code_ids = value.map(item => item.id);
                }
            },
            deep: true
        }
    },

    async created() {
        await this.getActiveIndicationsOfDangerSga();
        await this.getActiveTipsPrudenceSga();
    },

    methods: {
        ...mapActions('sgaIndicationsOfDanger', ['createIndicationOfDangerSga', 'getIndicationsOfDangerSga', 'updateIndicationOfDangerSga', 'getActiveIndicationsOfDangerSga']),
        ...mapMutations('sgaIndicationsOfDanger', ['setDefaultIndicationOfDangerSga']),
        ...mapActions('sgaTipsPrudence', ['getActiveTipsPrudenceSga']),

        cancelIndicationOfDanger() {
            this.setDefaultIndicationOfDangerSga();
            this.$bvModal.hide('modal_create_indication_of_danger');
        },

        async cancelAndGetIndicationOfDanger() {
            this.cancelIndicationOfDanger();
            await this.getIndicationsOfDangerSga();
        },

        async saveIndicationOfDanger() {
            const isValid = await this.$validator.validateAll('formIndicationOfDanger');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateIndicationOfDangerSga(this.indicationOfDanger);
            } else {
                flag = await this.createIndicationOfDangerSga(this.indicationOfDanger);
            }

            if (flag) {
                this.cancelAndGetIndicationOfDanger();
            }
        }
    }
}
</script>
